export const defaultTranslations = {
  location: '',
  map: 'Get Directions',
  milesAway: 'miles away',
  milesAwaySingular: 'mile away',
  terminationAlert: '',
  effectiveAlert: '',
  dismiss: 'Dismiss',
  medical_group_number: 'MG/IPA #',
  est: 'est.',
};

export type LocationTranslations = typeof defaultTranslations;

export function createTranslations<DefaultTranslations>(
  defaults: DefaultTranslations,
  overrides: Partial<DefaultTranslations>
): DefaultTranslations {
  return {
    ...defaults,
    ...overrides,
  };
}
